import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getReviseRecordById (id, page) {
  apiConsolelog('api: getReviseRecordById(): id = %d, page = %d', id, page)

  return request({
    url: '/survey-data/' + id + '/revise-records',
    method: 'get',
    page
  })
}
